import { render, staticRenderFns } from "./15SettlementReview.vue?vue&type=template&id=40e51058&"
import script from "./15SettlementReview.vue?vue&type=script&lang=js&"
export * from "./15SettlementReview.vue?vue&type=script&lang=js&"
import style0 from "./15SettlementReview.vue?vue&type=style&index=0&id=40e51058&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports